<div data-cy="deal-alert" class="deal-alert" *ngFor="let alert of dealAlerts$ | async">
  <app-alert
    [message]="alert.message"
    [level]="alert.level"
    (dismissed)="dismissAlert(alert)"
    [dismissDelay]="alert.dismissDelay">
  </app-alert>
</div>
